/* eslint-disable no-unused-vars */ /* eslint-disable no-unused-vars */
<template>
  <div class="main">

    <h1 class="title">自助服务</h1>
    <ul class="ul_box">
      <li @click="$router.push('/suggest')">
        <img src="@/imgs/v2/feedback.png"/>
        <p>意见反馈</p>
      </li>
      <!--<li @click="goToChat">-->
        <!--<img src="@/imgs/v2/consults.png"/>-->
        <!--<p>在线客服</p>-->
      <!--</li>-->
      <!--<li @click="show = true">-->
        <!--<img src="@/imgs/v2/refunds.png"/>-->
        <!--<p class="p1">全额退款</p>-->
        <!--<p class="p2">承诺时间到</p>-->
      <!--</li>-->
    </ul>
    <h1 class="title title2">人工服务</h1>
    <ul class="kfList">
      <li v-for="(item, index) of servicePhoneList"
          :key="index"
          @click="getTell(item.phone)">
        <img src="@/imgs/v2/telephone.png"/>
        <p>{{ item.name }}</p>
        <span>{{ $handlePhone(item.phone) }}</span>
      </li>
    </ul>
    <van-dialog
      v-model="show"
      :show-cancel-button="false"
      :show-confirm-button="false"
    >
      <div class="dialog">
        <h1>提示</h1>
        <p>
          您好，请联系在线客服申请核实
        </p>
        <div @click="show = false">我知道了</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { setLocal, getLocal } from '@/utils/cookie'
import { getSession } from '@/utils/util'
export default {
  name: 'Server',
  components: {
    vanDialog: Dialog.Component,
  },
  data() {
    return {
      topToastText: this.$store.getters.config.topToastText,
      show: false,
      servicePhoneList: [],
    }
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    goToChat() {
        window.location.href = "https://dm.aiyunkf.cc/index/index/home?visiter_id=&visiter_name=&avatar=&business_id=9&groupid=0&special=20"
      // var qimoClientId
      // if (getLocal('userChatId')) {
      //   qimoClientId = getLocal('userChatId') // 自定义用户的唯一id,由英文字母,数字,下划线组成
      // }else{
      //   const userChatId = getSession()
      //   qimoClientId = userChatId
      //   setLocal('userChatId',userChatId)
      // }
      // qimoChatClick()
    },
    async getConfig() {
      const data = await this.$store.dispatch('setConfig')
      this.servicePhoneList = data.servicePhoneList
      this.topToastText = data.topToastText
    },
    getTell(phone) {
      const a = document.createElement('a')
      a.href = `tel:${phone}`
      a.style.display = 'none'
      a.click()
    },
  },
}
</script>

<style lang="scss" scoped>
  .main {
    background: #F2F2F2;
    padding: 0 30px;
    overflow: hidden;
    .title {
      font-size: 32px;
      line-height: 70px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      margin-top: 10px;
    }
    .title2{
      margin-top: 40px;
    }
    .ul_box{
      width: 690px;
      height: 200px;
      background: #FFFFFF;
      box-shadow: 0px 5px 10px 0px #D5D1D1;
      border-radius: 8px;
      margin: 0 auto;
      padding: 0 15px;
      display: flex;
      li{
        width: 220px;
        p{
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #333333;
          text-align: center;
          line-height: 32px;
          margin-top: 11px;
        }
        img{
          width: 60px;
          height: 60px;
          display: block;
          margin: 33px auto 0;
        }
        .p1{
          color: #FF5B3B;
        }
        .p2{
          width: 240px;
          height: 48px;
          line-height: 48px;
          background: #FF5B3B;
          border-radius: 24px;
          font-size: 36px;
          transform: scale(0.5) translateX(-10px);
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          margin: -5px auto 0;
        }
      }
    }
    .kfList{
      display: flex;
      justify-content: space-between;
      li{
        width: 210px;
        height: 240px;
        background: #FFFFFF;
        box-shadow: 0px 5px 10px 0px #D5D1D1;
        border-radius: 8px;
        overflow: hidden;
        text-align: center;
        img{
          width: 64px;
          height: 74px;
          display: block;
          margin: 40px auto 0;
        }
        p{
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-top: 14px;
          line-height: 32px;
        }
        span{
          display: block;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #999999;
          margin-top: 8px;
          line-height: 32px;
        }
      }
    }
    .dialog {
      display: flex;
      flex-direction: column;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      padding: 0 63px 39px 63px;
      h1 {
        font-size: 36px;
        line-height: 120px;
        text-align: center;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(51, 51, 51, 1);
      }
      p {
        font-size: 28px;
        white-space: nowrap;
        text-align: center;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 36px;
      }
      div {
        margin: 62px auto 0 auto;
        width: 300px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        background: rgba(253, 106, 66, 1);
        border-radius: 8px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(254, 254, 254, 1);
      }
    }
  }
</style>
